import * as moment from "moment";
import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { Emotions } from "source/app/domain/Emotions/Emotions";
import Data from "source/app/services/Data";
import { Sounds } from "source/app/services/Sound/Sounds";
import { UpdateNodeAsync } from "source/app/services/Workflows/ChangeData/UpdateNodeAsync";
import {
    GetWorkflowsState,
    LoadWorkflowsDataAsync,
} from "../../../../Workflows";
import { AddPointToLogAsync } from "../AddPointToLogAsync";
import { GoToWorkflowNodeForInput } from "source/app/presentation/BottomBar/BottomLeftDashboard/NextActionLink/NextActionLink";
import { todayNodeName } from "motw_core/Repositories/WorkflowRepository";

export async function ExecuteNodeCompletion(node: IWorkflowNode) {
    Sounds.kickdrum_heavy.Play({ allowConcurrent: true });
    Sounds.clangSpacey.Play({ allowConcurrent: true });

    GoToWorkflowNodeForInput(todayNodeName);
    await UpdateDataForNodeCompletionAsync(node);
    await LoadWorkflowsDataAsync();
}

export async function UpdateDataForNodeCompletionAsync(node: IWorkflowNode) {
    const completedNodeName = GetCompletedNodeName(node);
    await UpdateNodeAsync(node, { name: completedNodeName });
    await AddPointToLogAsync(node.name);
}

function GetCompletedNodeName(node: IWorkflowNode) {
    const currentTime = moment().format("h:mm");
    const completedNodeName = `${node.name} ${Emotions.Current.character} ${currentTime}`;
    return completedNodeName;
}
